import { render, staticRenderFns } from "./EmailUs.vue?vue&type=template&id=7b070fd5"
import script from "./EmailUs.vue?vue&type=script&lang=js"
export * from "./EmailUs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports